var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 545.58 574.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4fb052;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:0px;}.cls-2{fill:#fcc010;}.cls-3{fill:none;}.cls-4{fill:#e9473a;}.cls-5{fill:#438ecc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.17,10.27v562.84l45.14,1.39,18.02-18.02,17.39,17.39-.64.64h44.36l-1.59-1.59,18.37-18.37,17.39,17.39-2.57,2.57h3.2l.97-.97.97.97h3.17l-2.55-2.55,18.37-18.37,17.39,17.39-3.53,3.53h3.2l1.93-1.93,1.93,1.93h3.17l-3.52-3.52,18.37-18.37,17.39,17.39-4.5,4.5h3.13l2.93-2.93,2.93,2.93h3.17l-4.52-4.52,18.37-18.37,17.39,17.39-5.5,5.5h3.2l3.9-3.9,3.9,3.9h3.17l-5.49-5.49,18.37-18.37,17.39,17.39-6.47,6.47h3.2l4.86-4.86,4.86,4.86h3.17l-6.45-6.45,18.37-18.37,17.39,17.39-7.43,7.43h3.2l5.83-5.83,5.83,5.83h3.57l-7.61-7.61,18.37-18.37,17.39,17.39-8.59,8.59h3.2l6.99-6.99,6.99,6.99h3.17l-8.58-8.58,18.37-18.37,17.39,17.39-9.56,9.56h3.2l7.96-7.96,7.96,7.96h3.17l-9.54-9.54,18.37-18.37,17.39,17.39-10.52,10.52h3.2l8.92-8.92,8.92,8.92h3.17l-10.51-10.51,18.37-18.37,17.39,17.39-11.49,11.49h3.2l9.89-9.89,9.89,9.89h3.17l-11.48-11.48,18.37-18.37,2.75,2.75v27.09h0V10.27H12.17ZM517.87,0l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM275.08,356.72l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM257.68,336.15l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM272.52,394.07l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM271.55,433.01l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM252.56,414.02l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM253,454.76l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM271.99,473.75l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM272.17,470.37l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM275.7,394.08l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM429.86,391.77l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM412.49,371.23l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM448.85,410.76l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM470.02,348.47l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM505.18,427.18l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM452.02,293.73l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM452,290.54l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM468.8,390.8l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM467.84,429.75l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM486.83,448.74l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM488.42,447.15l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM506.77,425.59l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM472.59,311.13l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM490.95,289.57l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM491.91,250.63l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM492.88,211.68l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM473.89,192.7l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM490.32,252.22l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM452.97,251.59l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM451.38,253.18l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM433.03,274.74l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM449.21,331.3l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM429.26,351.26l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM409.3,371.21l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM369.39,411.13l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM353.59,392.15l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM369.99,451.64l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM372.58,411.14l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM371.95,370.59l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM352.96,351.6l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM350.4,392.14l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM330.45,412.09l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM313.05,391.51l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM312.1,433.65l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM313.68,432.06l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM351.04,432.68l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM367.43,488.98l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM369.03,490.58l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM370.62,488.99l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM391.54,430.09l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM428.89,430.72l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM447.88,449.7l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM446.92,488.65l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM448.51,487.06l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM485.86,487.68l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM487.45,486.1l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM524.81,486.72l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM524.79,483.53l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM525.76,444.58l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM509.57,388.02l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM507.97,386.42l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM508.93,347.47l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM492.55,291.17l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM510.9,269.62l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM511.87,230.67l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM512.83,191.73l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM495.79,98.04l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM493.22,135.38l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM457.81,60.06l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM456.84,99.01l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM455.88,137.95l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM454.91,176.89l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM434.96,196.85l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM415,216.8l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM414.04,255.75l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM412.84,294.93l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM410.27,332.27l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM374.86,256.95l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM372.29,294.29l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM335.91,257.91l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM315.96,277.87l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM314.99,316.81l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM312.43,354.16l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM294.4,296.22l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM258.03,259.85l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM237.1,318.75l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM217.15,338.7l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM196.03,397.8l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM195.07,436.74l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM175.11,456.7l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM172.54,494.04l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM136.17,457.66l17.39,17.39-18.37,18.37-17.39-17.39,18.37-18.37ZM133.6,495.01l-18.37,18.37-17.39-17.39,18.37-18.37,17.39,17.39ZM0,517.87l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM36.38,554.25l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM38.94,516.91l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM75.32,553.28l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM78.85,477l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM114.27,552.32l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM134.22,532.36l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM153.21,551.35l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM173.17,531.4l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM192.16,550.39l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM211.14,569.37l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM212.11,530.43l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM214.04,452.54l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM250.09,568.41l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM252.66,531.07l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM289,567.41l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM308.95,547.45l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM312.72,471l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM330.71,528.9l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM367.08,565.28l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM387.04,545.33l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM406.03,564.32l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM406.99,525.37l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM409.56,488.03l18.37-18.37,17.39,17.39-18.37,18.37-17.39-17.39ZM444.97,563.35l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM464.93,543.39l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM483.92,562.38l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM503.87,542.43l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM522.86,561.42l-17.39-17.39,18.37-18.37,17.39,17.39-18.37,18.37ZM545.58,544.23l-1.16-1.16,1.16-1.16v2.32ZM545.58,538.7l-2.76,2.76-17.39-17.39,18.37-18.37,1.78,1.78v31.21ZM545.58,504.32l-.2-.2.2-.2v.39ZM545.58,500.72l-1.8,1.8-17.39-17.39,18.37-18.37.82.82v33.14ZM545.58,462.74l-.83.83-17.39-17.39,18.22-18.22v34.78ZM545.58,424.03l-17.02-17.02,17.02-17.02v34.04ZM545.58,384.12l-16.05-16.05,16.05-16.05v32.11ZM545.58,348.81l-17.66,17.66-17.39-17.39,18.37-18.37,16.68,16.68v1.43ZM545.58,344.21l-15.09-15.09,15.09-15.09v30.18ZM545.58,310.83l-16.69,16.69-17.39-17.39,18.37-18.37,15.71,15.71v3.36ZM545.58,272.92l-15.69,15.69-17.39-17.39,18.37-18.37,14.71,14.71v5.36ZM545.58,264.39l-13.12-13.12,13.12-13.12v26.24ZM545.58,234.94l-14.72,14.72-17.39-17.39,18.37-18.37,13.74,13.74v7.29ZM545.58,196.96l-13.76,13.76-17.39-17.39,18.37-18.37,12.78,12.78v9.22ZM545.58,158.98l-12.79,12.79-17.39-17.39,18.37-18.37,11.81,11.81v11.15ZM545.58,104.35l-9.06-9.06,9.06-9.06v18.13ZM545.58,24.53l-7.13-7.13,7.13-7.13v14.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.58 24.53 545.58 10.27 538.45 17.4 545.58 24.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.58 104.35 545.58 86.23 536.52 95.29 545.58 104.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 504.39,
    y: 5.58,
    width: 25.98,
    height: 24.59,
    transform: "translate(138.9 371.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.58 344.21 545.58 314.03 530.49 329.12 545.58 344.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "511.5 310.13 528.89 327.52 545.58 310.83 545.58 307.47 529.87 291.76 511.5 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.58 424.03 545.58 389.99 528.56 407.01 545.58 424.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 514.46,
    y: 375.23,
    width: 25.98,
    height: 24.59,
    transform: "translate(-119.54 486.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "545.58 384.12 545.58 352.01 529.53 368.06 545.58 384.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 495.47,
    y: 356.24,
    width: 25.98,
    height: 24.59,
    transform: "translate(-111.67 467.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "510.54 349.07 527.92 366.46 545.58 348.81 545.58 347.38 528.9 330.71 510.54 349.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 496.44,
    y: 317.3,
    width: 25.98,
    height: 24.59,
    transform: "translate(-83.85 456.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "515.4 154.39 532.79 171.77 545.58 158.98 545.58 147.83 533.77 136.02 515.4 154.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.58 264.39 545.58 238.14 532.46 251.26 545.58 264.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "513.47 232.27 530.86 249.66 545.58 234.94 545.58 227.65 531.84 213.91 513.47 232.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 499.37,
    y: 200.5,
    width: 25.98,
    height: 24.59,
    transform: "translate(-.4 424.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "514.43 193.33 531.82 210.72 545.58 196.96 545.58 187.74 532.8 174.96 514.43 193.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 480.38,
    y: 181.51,
    width: 25.98,
    height: 24.59,
    transform: "translate(7.46 405.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 500.33,
    y: 161.56,
    width: 25.98,
    height: 24.59,
    transform: "translate(27.42 413.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 482.31,
    y: 103.62,
    width: 25.98,
    height: 24.59,
    transform: "translate(63.1 384.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 444.33,
    y: 65.64,
    width: 25.98,
    height: 24.59,
    transform: "translate(78.83 346.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 461.39,
    y: 162.52,
    width: 25.98,
    height: 24.59,
    transform: "translate(15.33 386.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 442.4,
    y: 143.53,
    width: 25.98,
    height: 24.59,
    transform: "translate(23.19 367.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 462.36,
    y: 123.58,
    width: 25.98,
    height: 24.59,
    transform: "translate(43.15 375.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 443.37,
    y: 104.59,
    width: 25.98,
    height: 24.59,
    transform: "translate(51.01 356.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 497.44,
    y: 278.39,
    width: 25.98,
    height: 24.59,
    transform: "translate(-56.04 446.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "512.5 271.22 529.89 288.61 545.58 272.92 545.58 267.56 530.87 252.85 512.5 271.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 478.45,
    y: 259.4,
    width: 25.98,
    height: 24.59,
    transform: "translate(-48.18 427.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 498.4,
    y: 239.44,
    width: 25.98,
    height: 24.59,
    transform: "translate(-28.22 435.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 459.46,
    y: 240.41,
    width: 25.98,
    height: 24.59,
    transform: "translate(-40.31 408.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 479.41,
    y: 220.46,
    width: 25.98,
    height: 24.59,
    transform: "translate(-20.36 416.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 440.47,
    y: 221.42,
    width: 25.98,
    height: 24.59,
    transform: "translate(-32.45 389.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 457.53,
    y: 318.3,
    width: 25.98,
    height: 24.59,
    transform: "translate(-95.96 429.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 477.48,
    y: 298.34,
    width: 25.98,
    height: 24.59,
    transform: "translate(-76 437.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 438.54,
    y: 299.31,
    width: 25.98,
    height: 24.59,
    transform: "translate(-88.09 410.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 419.55,
    y: 280.32,
    width: 25.98,
    height: 24.59,
    transform: "translate(-80.22 391.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 439.5,
    y: 260.37,
    width: 25.98,
    height: 24.59,
    transform: "translate(-60.27 399.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 400.56,
    y: 261.33,
    width: 25.98,
    height: 24.59,
    transform: "translate(-72.36 372.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 420.51,
    y: 241.38,
    width: 25.98,
    height: 24.59,
    transform: "translate(-52.4 380.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 421.48,
    y: 202.43,
    width: 25.98,
    height: 24.59,
    transform: "translate(-24.58 370.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 441.44,
    y: 182.48,
    width: 25.98,
    height: 24.59,
    transform: "translate(-4.63 378.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 401.52,
    y: 222.39,
    width: 25.98,
    height: 24.59,
    transform: "translate(-44.54 361.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "545.58 504.32 545.58 503.92 545.38 504.12 545.58 504.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "526.39 485.13 543.78 502.52 545.58 500.72 545.58 467.58 544.76 466.76 526.39 485.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 512.29,
    y: 453.36,
    width: 25.98,
    height: 24.59,
    transform: "translate(-175.41 507.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "544.75 463.57 545.58 462.74 545.58 427.97 527.36 446.19 544.75 463.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "542.83 544.65 524.46 563.02 535.94 574.5 545.58 574.5 545.58 547.4 542.83 544.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "545.58 544.23 545.58 541.9 544.42 543.06 545.58 544.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 510.36,
    y: 531.24,
    width: 25.98,
    height: 24.59,
    transform: "translate(-231.05 529.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "525.43 524.07 542.82 541.46 545.58 538.7 545.58 507.49 543.8 505.71 525.43 524.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 491.37,
    y: 512.25,
    width: 25.98,
    height: 24.59,
    transform: "translate(-223.19 510.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 511.33,
    y: 492.3,
    width: 25.98,
    height: 24.59,
    transform: "translate(-203.23 518.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 472.38,
    y: 493.27,
    width: 25.98,
    height: 24.59,
    transform: "translate(-215.32 491.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 492.34,
    y: 473.31,
    width: 25.98,
    height: 24.59,
    transform: "translate(-195.37 499.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 493.31,
    y: 434.37,
    width: 25.98,
    height: 24.59,
    transform: "translate(-167.55 488.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 513.26,
    y: 414.41,
    width: 25.98,
    height: 24.59,
    transform: "translate(-147.59 497.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 474.32,
    y: 415.38,
    width: 25.98,
    height: 24.59,
    transform: "translate(-159.68 469.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 494.27,
    y: 395.42,
    width: 25.98,
    height: 24.59,
    transform: "translate(-139.73 478.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 455.33,
    y: 396.39,
    width: 25.98,
    height: 24.59,
    transform: "translate(-151.82 450.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.4,
    y: 474.28,
    width: 25.98,
    height: 24.59,
    transform: "translate(-207.46 472.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 473.35,
    y: 454.32,
    width: 25.98,
    height: 24.59,
    transform: "translate(-187.5 480.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 434.41,
    y: 455.29,
    width: 25.98,
    height: 24.59,
    transform: "translate(-199.59 453.31) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 454.36,
    y: 435.33,
    width: 25.98,
    height: 24.59,
    transform: "translate(-179.64 461.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 415.42,
    y: 436.3,
    width: 25.98,
    height: 24.59,
    transform: "translate(-191.73 434.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 435.37,
    y: 416.34,
    width: 25.98,
    height: 24.59,
    transform: "translate(-171.77 442.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 396.43,
    y: 417.31,
    width: 25.98,
    height: 24.59,
    transform: "translate(-183.86 415.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 416.38,
    y: 397.35,
    width: 25.98,
    height: 24.59,
    transform: "translate(-163.91 423.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "512.99 574.5 532.76 574.5 522.87 564.61 512.99 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "475.01 574.5 492.85 574.5 483.93 565.57 475.01 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "503.89 545.62 485.52 563.98 496.03 574.5 509.78 574.5 521.27 563 503.89 545.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "464.94 546.58 446.57 564.95 456.12 574.5 471.8 574.5 482.33 563.97 464.94 546.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 471.42,
    y: 532.21,
    width: 25.98,
    height: 24.59,
    transform: "translate(-243.14 502.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 432.47,
    y: 533.18,
    width: 25.98,
    height: 24.59,
    transform: "translate(-255.23 474.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 452.43,
    y: 513.22,
    width: 25.98,
    height: 24.59,
    transform: "translate(-235.28 483.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "437.03 574.5 452.94 574.5 444.99 566.54 437.03 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "399.05 574.5 413.03 574.5 406.04 567.5 399.05 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "426 547.55 407.63 565.92 416.21 574.5 433.83 574.5 443.38 564.94 426 547.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 433.44,
    y: 494.23,
    width: 25.98,
    height: 24.59,
    transform: "translate(-227.41 464.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 394.5,
    y: 495.2,
    width: 25.98,
    height: 24.59,
    transform: "translate(-239.5 436.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 414.45,
    y: 475.24,
    width: 25.98,
    height: 24.59,
    transform: "translate(-219.55 445.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 375.51,
    y: 476.21,
    width: 25.98,
    height: 24.59,
    transform: "translate(-231.64 417.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 356.52,
    y: 457.22,
    width: 25.98,
    height: 24.59,
    transform: "translate(-223.77 398.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "387.05 548.51 368.68 566.88 376.3 574.5 395.85 574.5 404.44 565.9 387.05 548.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 393.53,
    y: 534.14,
    width: 25.98,
    height: 24.59,
    transform: "translate(-267.32 447.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 354.59,
    y: 535.11,
    width: 25.98,
    height: 24.59,
    transform: "translate(-279.41 420.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 374.54,
    y: 515.15,
    width: 25.98,
    height: 24.59,
    transform: "translate(-259.46 428.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 335.6,
    y: 516.12,
    width: 25.98,
    height: 24.59,
    transform: "translate(-271.55 401.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 355.55,
    y: 496.16,
    width: 25.98,
    height: 24.59,
    transform: "translate(-251.59 409.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 336.56,
    y: 477.17,
    width: 25.98,
    height: 24.59,
    transform: "translate(-243.73 390.53) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 417.38,
    y: 358.44,
    width: 25.98,
    height: 24.59,
    transform: "translate(-136.1 412.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 398.39,
    y: 339.45,
    width: 25.98,
    height: 24.59,
    transform: "translate(-128.23 393.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 418.35,
    y: 319.5,
    width: 25.98,
    height: 24.59,
    transform: "translate(-108.28 402.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 379.4,
    y: 320.46,
    width: 25.98,
    height: 24.59,
    transform: "translate(-120.37 374.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 399.36,
    y: 300.51,
    width: 25.98,
    height: 24.59,
    transform: "translate(-100.41 383.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 377.47,
    y: 398.35,
    width: 25.98,
    height: 24.59,
    transform: "translate(-176.01 396.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 358.48,
    y: 379.36,
    width: 25.98,
    height: 24.59,
    transform: "translate(-168.14 377.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 378.44,
    y: 359.41,
    width: 25.98,
    height: 24.59,
    transform: "translate(-148.19 385.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 359.45,
    y: 340.42,
    width: 25.98,
    height: 24.59,
    transform: "translate(-140.32 366.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 340.46,
    y: 321.43,
    width: 25.98,
    height: 24.59,
    transform: "translate(-132.46 347.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 341.43,
    y: 282.49,
    width: 25.98,
    height: 24.59,
    transform: "translate(-104.64 336.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 361.38,
    y: 262.53,
    width: 25.98,
    height: 24.59,
    transform: "translate(-84.68 345.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 322.44,
    y: 263.5,
    width: 25.98,
    height: 24.59,
    transform: "translate(-96.77 317.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.52,
    y: 322.4,
    width: 25.98,
    height: 24.59,
    transform: "translate(-144.55 320.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 302.48,
    y: 283.45,
    width: 25.98,
    height: 24.59,
    transform: "translate(-116.73 309.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 263.54,
    y: 284.42,
    width: 25.98,
    height: 24.59,
    transform: "translate(-128.82 282.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 244.55,
    y: 265.43,
    width: 25.98,
    height: 24.59,
    transform: "translate(-120.95 263.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 337.56,
    y: 438.26,
    width: 25.98,
    height: 24.59,
    transform: "translate(-215.92 379.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 318.57,
    y: 419.27,
    width: 25.98,
    height: 24.59,
    transform: "translate(-208.05 360.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 338.53,
    y: 399.32,
    width: 25.98,
    height: 24.59,
    transform: "translate(-188.1 369.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 299.58,
    y: 400.29,
    width: 25.98,
    height: 24.59,
    transform: "translate(-200.19 341.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 319.54,
    y: 380.33,
    width: 25.98,
    height: 24.59,
    transform: "translate(-180.23 350.13) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 280.59,
    y: 381.3,
    width: 25.98,
    height: 24.59,
    transform: "translate(-192.32 322.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 300.55,
    y: 361.34,
    width: 25.98,
    height: 24.59,
    transform: "translate(-172.37 331.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 317.61,
    y: 458.22,
    width: 25.98,
    height: 24.59,
    transform: "translate(-235.87 371.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 298.62,
    y: 439.23,
    width: 25.98,
    height: 24.59,
    transform: "translate(-228.01 352.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 259.67,
    y: 440.2,
    width: 25.98,
    height: 24.59,
    transform: "translate(-240.1 325.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 240.68,
    y: 421.21,
    width: 25.98,
    height: 24.59,
    transform: "translate(-232.23 306.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 261.61,
    y: 362.31,
    width: 25.98,
    height: 24.59,
    transform: "translate(-184.46 303.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 281.56,
    y: 342.35,
    width: 25.98,
    height: 24.59,
    transform: "translate(-164.5 312.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 262.57,
    y: 323.36,
    width: 25.98,
    height: 24.59,
    transform: "translate(-156.64 293.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 223.63,
    y: 324.33,
    width: 25.98,
    height: 24.59,
    transform: "translate(-168.73 265.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 221.69,
    y: 402.22,
    width: 25.98,
    height: 24.59,
    transform: "translate(-224.37 287.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 241.65,
    y: 382.26,
    width: 25.98,
    height: 24.59,
    transform: "translate(-204.41 295.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 203.67,
    y: 344.28,
    width: 25.98,
    height: 24.59,
    transform: "translate(-188.68 257.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "361.07 574.5 372.73 574.5 366.9 568.67 361.07 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "323.09 574.5 332.82 574.5 327.96 569.63 323.09 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "347.91 549.68 329.54 568.04 336 574.5 357.87 574.5 365.3 567.06 347.91 549.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "308.97 550.64 290.6 569.01 296.09 574.5 319.89 574.5 326.36 568.03 308.97 550.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 276.5,
    y: 537.24,
    width: 25.98,
    height: 24.59,
    transform: "translate(-303.79 365.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 296.46,
    y: 517.28,
    width: 25.98,
    height: 24.59,
    transform: "translate(-283.83 373.92) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "285.11 574.5 292.91 574.5 289.01 570.6 285.11 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "247.14 574.5 253 574.5 250.07 571.56 247.14 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "270.02 551.61 251.66 569.98 256.18 574.5 281.91 574.5 287.41 569 270.02 551.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.55,
    y: 518.28,
    width: 25.98,
    height: 24.59,
    transform: "translate(-295.94 346.7) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.51,
    y: 479.34,
    width: 25.98,
    height: 24.59,
    transform: "translate(-268.12 335.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 239.52,
    y: 460.35,
    width: 25.98,
    height: 24.59,
    transform: "translate(-260.25 316.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.11 552.61 212.75 570.98 216.26 574.5 244 574.5 248.5 570 231.11 552.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.59,
    y: 538.24,
    width: 25.98,
    height: 24.59,
    transform: "translate(-315.89 338.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 198.65,
    y: 539.2,
    width: 25.98,
    height: 24.59,
    transform: "translate(-327.98 311.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 179.66,
    y: 520.21,
    width: 25.98,
    height: 24.59,
    transform: "translate(-320.11 292.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 199.61,
    y: 500.26,
    width: 25.98,
    height: 24.59,
    transform: "translate(-300.16 300.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.67,
    y: 501.22,
    width: 25.98,
    height: 24.59,
    transform: "translate(-312.25 273.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.59,
    y: 442.32,
    width: 25.98,
    height: 24.59,
    transform: "translate(-264.47 270.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 201.54,
    y: 422.37,
    width: 25.98,
    height: 24.59,
    transform: "translate(-244.52 279.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 182.55,
    y: 403.38,
    width: 25.98,
    height: 24.59,
    transform: "translate(-236.65 260.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.68,
    y: 482.23,
    width: 25.98,
    height: 24.59,
    transform: "translate(-304.38 254.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 161.63,
    y: 462.28,
    width: 25.98,
    height: 24.59,
    transform: "translate(-284.43 262.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 122.69,
    y: 463.24,
    width: 25.98,
    height: 24.59,
    transform: "translate(-296.52 235.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "209.23 574.5 213.09 574.5 211.16 572.56 209.23 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.25 574.5 173.18 574.5 172.21 573.53 171.25 574.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "192.17 553.57 173.8 571.94 176.35 574.5 206.02 574.5 209.56 570.96 192.17 553.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "153.22 554.54 134.86 572.91 136.44 574.5 168.05 574.5 170.61 571.93 153.22 554.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 140.71,
    y: 521.18,
    width: 25.98,
    height: 24.59,
    transform: "translate(-332.2 264.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.77,
    y: 522.14,
    width: 25.98,
    height: 24.59,
    transform: "translate(-344.29 237.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 121.72,
    y: 502.19,
    width: 25.98,
    height: 24.59,
    transform: "translate(-324.34 245.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 102.73,
    y: 483.2,
    width: 25.98,
    height: 24.59,
    transform: "translate(-316.47 226.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 83.74,
    y: 464.21,
    width: 25.98,
    height: 24.59,
    transform: "translate(-308.61 207.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.34 556.47 57.31 574.5 92.09 574.5 92.72 573.86 75.34 556.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62.82,
    y: 523.11,
    width: 25.98,
    height: 24.59,
    transform: "translate(-356.38 210.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.88,
    y: 524.08,
    width: 25.98,
    height: 24.59,
    transform: "translate(-368.47 183.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.83,
    y: 504.12,
    width: 25.98,
    height: 24.59,
    transform: "translate(-348.52 191.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.89,
    y: 505.09,
    width: 25.98,
    height: 24.59,
    transform: "translate(-360.61 164.18) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftBlocks);
export default __webpack_public_path__ + "static/media/microsoft_blocks.c19637f34b7334c65a51bc329f8154b2.svg";
export { ForwardRef as ReactComponent };